import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import Userform from './pages/Userform';
import Mainmenu from './pages/MainMenu';
import ResetPassword from './components/menu/ResetPassword';

import { createTheme, responsiveFontSizes, ThemeProvider } from '@mui/material/styles';
import CssBaseline from '@mui/material/CssBaseline';

let theme = createTheme({
  typography: {
    fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
    // Tamaños optimizados para móvil por defecto
    h6: {
      fontSize: '1.25rem', // Tamaño estándar PC
      '@media (max-width:600px)': {
        fontSize: '1.05rem', // Tamaño reducido Móvil
      },
      fontWeight: 600,
    },
    subtitle1: {
      fontSize: '0.9rem',
    },
    body1: {fontSize: '1rem', // Tamaño estándar PC
      '@media (max-width:600px)': {
        fontSize: '0.85rem', // Tamaño reducido Móvil
      },
    },
    body2: {
      fontSize: '0.875rem', // Tamaño estándar PC
      '@media (max-width:600px)': {
        fontSize: '0.75rem', // Tamaño reducido Móvil
      },
    },
    button: {
      textTransform: 'none',
      fontSize: '0.875rem',
      '@media (max-width:600px)': {
        fontSize: '0.75rem', // Botones más compactos en móvil
      },
    },
  },

  components: {
    MuiSvgIcon: {
      styleOverrides: {
        root: {
          // Usamos fontSize para que no bajen de este tamaño
          fontSize: '22px', 
          '@media (max-width:600px)': {
            fontSize: '20px', // Tamaño cómodo en móvil
          },
        },
      },
    },
    MuiInputBase: {
      styleOverrides: {
          root: {
          '@media (max-width:600px)': {
            fontSize: '0.9rem', 
          },
        },
      },
    },
  },
  
  // Colores globales (opcional, por si quieres que el error sea siempre el mismo rojo)
  palette: {
    error: {
      main: '#d32f2f', // red[700]
    },
  },
});

// Aplicamos la magia del escalado automático para encabezados
theme = responsiveFontSizes(theme);

/**
 * 1. GUARDIA DE AUTENTICACIÓN: ¿Está logueado?
 */
const PrivateRoute = ({ children }) => {
    const token = localStorage.getItem('token');
    // Si no hay token, lo mandamos al login
    return token ? children : <Navigate to="/home" replace />;
};

/**
 * 2. GUARDIA DE ROLES: ¿Tiene permiso para ver esto?

const RoleGuard = ({ children, allowedRoles }) => {
    const user = JSON.parse(localStorage.getItem('user'));
    
    if (!user || !allowedRoles.includes(user.role)) {
        // Si no tiene el rol, lo mandamos a una página neutral dentro del sistema
        return <Navigate to="/home/menu" replace />;
    }
    return children;
};

 */

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      {/* CssBaseline asegura que el fondo y las fuentes base se apliquen correctamente */}
      <CssBaseline />
        <BrowserRouter>
            <Routes>

              <Route path='/home' element={<Userform/>}/>
              <Route path="/reset-password/:token" element={<ResetPassword />} />


              <Route path='/home/menu/*' element={
                <PrivateRoute>
                  <Mainmenu/>
                </PrivateRoute>
              }/>
              
              <Route path="/" element={<Navigate to="/home" replace />} />
            </Routes>   
        </BrowserRouter>
    </ThemeProvider>
  )
}